module.exports = __webpack_public_path__ + "media/recipes/33-782889e4.png";